export const USER_ERROR_MESSAGES = {
  FETCH_USERS: "Failed to fetch users",
  FETCH_USER: "Failed to fetch user",
  CREATE_USER: "Failed to create user",
  UPDATE_USER: "Failed to update user",
  DELETE_USER: "Failed to delete user",
  FETCH_PERMISSIONS: "Failed to fetch user permissions",
};

export const ROLE_ERROR_MESSAGES = {
  FETCH_ROLES: "Failed to fetch roles",
  FETCH_ROLE: "Failed to fetch role",
  CREATE_ROLE: "Failed to create role",
  UPDATE_ROLE: "Failed to update role",
  DELETE_ROLE: "Failed to delete role",
  FETCH_ROLE_PERMISSIONS: "Failed to fetch role permissions",
};

export const POLICY_ERROR_MESSAGES = {
  FETCH_POLICIES: "Failed to fetch policies",
  FETCH_POLICY: "Failed to fetch policy",
  CREATE_POLICY: "Failed to create policy",
  UPDATE_POLICY: "Failed to update policy",
  DELETE_POLICY: "Failed to delete policy",
};

// Fallback role options when backend roles haven't loaded yet
export const ROLE_OPTIONS = [
  { value: "READ", label: "Read Only" },
  { value: "CUSTOM", label: "Custom" },
  { value: "ADMIN", label: "Administrator" },
];

export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];

export const EFFECT_OPTIONS = [
  { value: "ALLOW", label: "Allow" },
  { value: "DENY", label: "Deny" },
];

// All available RBAC permissions (feature:action pairs)
export const AVAILABLE_PERMISSIONS = [
  { value: "fleet:read", label: "Fleet - Read" },
  { value: "fleet:write", label: "Fleet - Write" },
  { value: "fleet:execute", label: "Fleet - Execute" },
  { value: "stations:read", label: "Stations - Read" },
  { value: "stations:write", label: "Stations - Write" },
  { value: "stations:execute", label: "Stations - Execute" },
  { value: "chargers:read", label: "Chargers - Read" },
  { value: "chargers:write", label: "Chargers - Write" },
  { value: "chargers:execute", label: "Chargers - Execute" },
  { value: "charger_remote:read", label: "Charger Remote - Read" },
  { value: "charger_remote:write", label: "Charger Remote - Write" },
  { value: "charger_remote:execute", label: "Charger Remote - Execute" },
  { value: "commands:read", label: "Commands - Read" },
  { value: "commands:write", label: "Commands - Write" },
  { value: "commands:execute", label: "Commands - Execute" },
  { value: "troubleshooting:read", label: "Troubleshooting - Read" },
  { value: "troubleshooting:write", label: "Troubleshooting - Write" },
  { value: "troubleshooting:execute", label: "Troubleshooting - Execute" },
  { value: "ocpp_messages:read", label: "OCPP Messages - Read" },
  { value: "ocpp_messages:write", label: "OCPP Messages - Write" },
  { value: "ocpp_messages:execute", label: "OCPP Messages - Execute" },
  { value: "user_management:read", label: "User Management - Read" },
  { value: "user_management:write", label: "User Management - Write" },
  { value: "user_management:execute", label: "User Management - Execute" },
];
